import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_method_details: {
    title: '{{orderMethod}} in {{waitingTime}} mins',
  },
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Delivery',
    [ORDER_METHODS.PICKUP]: 'Pickup',
    [ORDER_METHODS.ROOM_SERVICE]: 'Room Service',
  },
};
